<div class="card custom__card">
  <ng-content></ng-content>
</div>
